import React, { Component } from 'react';
import UserAddress from './useraddress';
import UserEmails from './useremails';
import UserFirstLastNames from './userfirstlastnames';
import UserPhoneNumbers from './userphonenumbers';
import { mapKeys, merge } from 'lodash';

var tr = require('ts-translate-js').default.boundTR;


class GuestClient extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount(){
        if (this.props.onContentChange)
            this.props.onContentChange();
    }

    componentDidUpdate(){
        if (this.props.onContentChange)
            this.props.onContentChange();
    }

    handleOnNamesChange(names) {
        var guestClientUpdated = merge({}, this.props.guestClient, names);
        this.props.onGuestClientInfoChanged(guestClientUpdated);
    }

    handleOnEmailsChange(emails) {
        var guestClientUpdated = merge({}, this.props.guestClient, emails);
        this.props.onGuestClientInfoChanged(guestClientUpdated);
    }

    handleOnPhoneNumberChange(phoneNumber) {
        var guestClientUpdated = merge({}, this.props.guestClient, phoneNumber);
        this.props.onGuestClientInfoChanged(guestClientUpdated);
    }

    handleOnPostalCodeChange(mainAddress) {
        var fMap = {PostalCode: 'postalCode'};
        var change = mapKeys(mainAddress, (_, name) => fMap[name]);
        var guestClientUpdated = merge({}, this.props.guestClient, change);
        this.props.onGuestClientInfoChanged(guestClientUpdated);
    }

    handleOnAddressChanged(address) {
        var fMap = {Address1: 'address', Address2: 'address2', Province: 'province', City: 'city', Country: 'country', PostalCode: 'postalCode'};
        var change = mapKeys(address, (_, name) => fMap[name]);
        var guestClientUpdated = merge({}, this.props.guestClient, change);
        this.props.onGuestClientInfoChanged(guestClientUpdated);
    }

    createPostalCodeErrorMessage() {
        if (this.props.showGuestClientCreationError && this.props.guestClientCreationError != null) {
            return (this.props.guestClientCreationError.InvalidPostalCodeFormat) ?
                <span id="helpBlock" className="help-block">{tr("profileedition.postalcodeformat")}</span>
                : (this.props.guestClientCreationError.MissingFields.includes("postalCode")) ?
                    <span id="helpBlock" className="help-block">{tr("Requis")}</span>
                    : null;
        }

        return null; 
    }

    createPhoneNumberErrorMessage() {
        if (this.props.showGuestClientCreationError && this.props.guestClientCreationError != null) {
            return (this.props.guestClientCreationError.InvalidEveningPhoneFormat) ?
                <span id="helpBlock" className="help-block">{tr("profileedition.phoneformat")}</span>
                : (this.props.guestClientCreationError.MissingFields.includes("homePhone")) ?
                    <span id="helpBlock" className="help-block">{tr("Requis")}</span>
                    : null;
        }

        return null;
    }

    createEmailErrorMessage() {
        if (this.props.showGuestClientCreationError && this.props.guestClientCreationError != null) {
            return (this.props.guestClientCreationError.InvalidEmailFormat) ?
                <span id="helpBlock" className="help-block">{tr("profileedition.emailformat")}</span>
                : (this.props.guestClientCreationError.MissingFields.includes("email")) ?
                    <span id="helpBlock" className="help-block">{tr("Requis")}</span>
                    : null;
        }

        return null;
    }

    createPhoneNumberAndWholeAddressInputs(postalCodeErrorMessage, phoneNumberErrorMessage) {
        var phoneNumberInput = this.createPhoneNumberInput(phoneNumberErrorMessage);

        return (
            <div>
                {phoneNumberInput}
                <UserAddress
                    MainAddress={{
                        Address1: this.props.guestClient.address,
                        Address2: this.props.guestClient.address2,
                        City: this.props.guestClient.city,
                        Province: this.props.guestClient.province,
                        Country: this.props.guestClient.country,
                        PostalCode: this.props.guestClient.postalCode
                    }}
                    showWholeAddress={true}
                    postalCodeErrorMessage={postalCodeErrorMessage}
                    showProfileEditionError={this.props.showGuestClientCreationError}
                    handleOnAddressChange={(address) => this.handleOnAddressChanged(address)}
                />
            </div>
        )
    }

    createPhoneNumberWithPostalCodeInputs(postalCodeErrorMessage, phoneNumberErrorMessage) {
        var postalCodeInput = this.createPostalInput(postalCodeErrorMessage);
        var phoneNumberInput = this.createPhoneNumberInput(phoneNumberErrorMessage);

        return (
            <div>
                {phoneNumberInput}
                {postalCodeInput}
            </div>
        )
    }

    createPostalInput(postalCodeErrorMessage) {
        return (
            <div>
                <UserAddress
                    MainAddress={ { PostalCode:this.props.guestClient.postalCode } }
                    showProfileEditionError={this.props.showGuestClientCreationError}
                    handleOnAddressChange={(postalCode) => this.handleOnPostalCodeChange(postalCode)}
                    postalCodeErrorMessage={postalCodeErrorMessage}
                    showWholeAddress={false} />
            </div>
        );
    }

    createPhoneNumberInput(phoneNumberErrorMessage) {
        return (
            <UserPhoneNumbers
                phoneEvening={this.props.guestClient.homePhone}
                showBothPhoneNumbers={false}
                showProfileEditionError={this.props.showGuestClientCreationError}
                phoneEveningErrorMessage={phoneNumberErrorMessage}
                handleOnPhoneNumbersChange={(phoneNumber) => this.handleOnPhoneNumberChange(phoneNumber)} />
        );
    }
    
    render() {
        var postalCodeErrorMessage = this.createPostalCodeErrorMessage();
        var phoneNumberErrorMessage = this.createPhoneNumberErrorMessage();
        var emailErrorMessage = this.createEmailErrorMessage();
        
        var phoneNumberAndAddressInputs = this.props.showWholeForm ? 
            this.createPhoneNumberAndWholeAddressInputs(postalCodeErrorMessage, phoneNumberErrorMessage)
            : this.createPhoneNumberWithPostalCodeInputs(postalCodeErrorMessage, phoneNumberErrorMessage);

        return (
            <div className="row">
                <div className="col-sm-6 col-md-4">
                    <UserEmails
                        email={this.props.guestClient.email}
                        emailValidation={this.props.emailValidation}
                        isNew={this.props.isNew}
                        handleOnEmailsChange={(emails) => this.handleOnEmailsChange(emails)}
                        emailErrorMessage={emailErrorMessage} />
                </div>
                <div className="col-sm-6 col-md-4">
                    <UserFirstLastNames
                        firstName={this.props.guestClient.firstName}
                        lastName={this.props.guestClient.lastName}
                        handleOnNamesChange={(names) => this.handleOnNamesChange(names)}
                        showProfileEditionError={this.props.showGuestClientCreationError} />
                </div>
                <div className="col-sm-6 col-md-4">
                    {phoneNumberAndAddressInputs}
                </div>
                <br/>
            </div>
        )
    };
}

export default GuestClient;
